import scanSound from 'themes/sounds/scanSound.mp3';
import errorScanSound from 'themes/sounds/errorScanSound.wav';

class SoundService {
	success = async () => {
		const audio = new Audio(scanSound);
		await audio.play();
	};

	error = async () => {
		const audio = new Audio(errorScanSound);
		await audio.play();
	};
}

export default SoundService;
